import config from "../config";

const daysLeftFilter = (dataArray) =>
  dataArray.filter((obj) => obj.days_left <= config.DAYS_LEFT_WARNING).length;
export default daysLeftFilter;
